import { setContext, getContext } from 'svelte';
import { writable } from 'svelte/store';
/**
 * Ensures that Sq.Tracking module from public-web-styles is initialized.
 *
 * @returns Promise that resolves once Sq.Tracking has initialized.
 */
function waitForTrackingInitialization() {
    const waitFor = (resolve) => {
        if (typeof window !== 'undefined' &&
            window.Sq &&
            window.Sq.Tracking &&
            window.Sq.Tracking.config &&
            window.Sq.Tracking.cdp) {
            resolve();
        }
        else {
            setTimeout(() => waitFor(resolve), 100);
        }
    };
    return new Promise(waitFor);
}
function waitForWindow() {
    const waitFor = (resolve) => {
        if (typeof window === 'undefined') {
            setTimeout(() => waitFor(resolve), 100);
        }
        else {
            resolve();
        }
    };
    return new Promise(waitFor);
}
const filterCDPProperties = (props) => {
    const filteredProps = {};
    for (const [key, value] of Object.entries(props)) {
        if (value !== undefined) {
            filteredProps[key] = value;
        }
    }
    return filteredProps;
};
export const onActivePWTPage = (pages) => {
    if (pages === null || !Array.isArray(pages) || pages.length === 0) {
        return false;
    }
    if (pages[0] === '*') {
        return true;
    }
    return pages.includes(window.location.pathname);
};
function makeTrackFn(flags) {
    return async ({ eventName, properties = {} }) => {
        await waitForWindow();
        const enablePwtXMS2 = flags.get('xms2-enable-pwt');
        const usePwt = Boolean(enablePwtXMS2);
        const filteredProps = filterCDPProperties(properties);
        if (usePwt) {
            window.Sq.Tracking.track({
                action: eventName,
                properties: filteredProps,
            }, { destinations: ['cdp'] });
        }
        else {
            await waitForTrackingInitialization();
            window.Sq.Tracking.cdp.track(eventName, filteredProps);
        }
    };
}
function getOneTrustConsent(flags) {
    const initialValue = {
        functionalityTrackingEnabled: false,
        analyticsTrackingEnabled: false,
        advertisingTrackingEnabled: false,
    };
    const store = writable(initialValue);
    if (typeof window === 'undefined') {
        return store;
    }
    const enablePwtXMS2 = flags.get('xms2-enable-pwt');
    const usePwt = Boolean(enablePwtXMS2);
    if (usePwt) {
        window.Sq.Tracking.subscribe('sq:oneTrustInitialized', (ev) => {
            const { functionalityTrackingEnabled, analyticsTrackingEnabled, advertisingTrackingEnabled } = ev.detail;
            store.set({
                functionalityTrackingEnabled,
                analyticsTrackingEnabled,
                advertisingTrackingEnabled,
            });
        });
    }
    else {
        (async () => {
            await waitForTrackingInitialization();
            window.Sq.Tracking.eventQueue.enqueue(() => {
                store.set({
                    functionalityTrackingEnabled: window.Sq?.OneTrust?.functionalityTrackingEnabled ?? false,
                    analyticsTrackingEnabled: window.Sq?.OneTrust?.analyticsTrackingEnabled ?? false,
                    advertisingTrackingEnabled: window.Sq?.OneTrust?.advertisingTrackingEnabled ?? false,
                });
            });
        })();
    }
    return store;
}
export const trackingContextKey = Symbol('trackingContextKey');
export const oneTrustContextKey = Symbol('oneTrustContextKey');
export function initTracking(flags) {
    setContext(trackingContextKey, makeTrackFn(flags));
    setContext(oneTrustContextKey, getOneTrustConsent(flags));
}
export function getTracking() {
    return getContext(trackingContextKey);
}
export function getOneTrustContext() {
    return getContext(oneTrustContextKey);
}
